__turbopack_context__.v({
  "columnDown": "FloatingMarquee-module__B7BJSa__columnDown",
  "columnUp": "FloatingMarquee-module__B7BJSa__columnUp",
  "floatingItem": "FloatingMarquee-module__B7BJSa__floatingItem",
  "leftSide": "FloatingMarquee-module__B7BJSa__leftSide",
  "marqueeColumn": "FloatingMarquee-module__B7BJSa__marqueeColumn",
  "marqueeDown": "FloatingMarquee-module__B7BJSa__marqueeDown",
  "marqueeSet": "FloatingMarquee-module__B7BJSa__marqueeSet",
  "marqueeUp": "FloatingMarquee-module__B7BJSa__marqueeUp",
  "marqueeWrapper": "FloatingMarquee-module__B7BJSa__marqueeWrapper",
  "rightSide": "FloatingMarquee-module__B7BJSa__rightSide",
});
